/* unplugin-vue-components disabled */import { render } from "./member_record_m.vue?vue&type=template&id=2806c11e&scoped=true"
import script from "./member_record_m.vue?vue&type=script&lang=js"
export * from "./member_record_m.vue?vue&type=script&lang=js"

import "./member_record_m.vue?vue&type=style&index=0&id=2806c11e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2806c11e"]])

export default __exports__